const inputs = {
  id: {
    id: 'worktemplate_id',
    name: 'id'
  },
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'workflowList.form.name.label',
    placeholder: 'workflowList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textArea',
    label: 'workflowList.form.description.label',
    placeholder: 'workflowList.form.description.placeholder',
    minRows: 2,
  },
  project: {
    id: 'proyect_id',
    name: 'project',
    input: 'select',
    label: 'workflowList.form.project.label',
    helperText: 'workflowList.form.project.helperText',
  },
  userProject: {
    id: 'user',
    name: 'userProject',
    input: 'select',
    label: 'workflowList.form.userProject.label',
    helperText: 'workflowList.form.userProject.helperText',
  },
  notificationType: {
    id: 'tipo',
    name: 'notificationType',
    input: 'select',
    label: 'workflowList.form.notificationType.label',
  },
  notifications: {
    id: 'notifications',
    type: 'array',
    name: 'notifications',
  },
  workflowDefinition: {
    id: 'wf_definition',
    name: 'workflowDefinition'
  }
};

export default inputs;
